import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "members-list small-av"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { href: "javascript:void(0)" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }),
  /*#__PURE__*/_createTextVNode(" No members Yet !")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListUserPermissionDetail = _resolveComponent("ToDoListUserPermissionDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.projectMembers && _ctx.projectMembers.length)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectMembers, (member, memberIndex) => {
              return (_openBlock(), _createBlock("li", {
                class: "member-img-cirlce",
                key: memberIndex
              }, [
                (member.full_name)
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      (member.role != 4)
                        ? (_openBlock(), _createBlock("div", _hoisted_3, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.showUserDetails(member))
                            }, [
                              (member.image)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: member.image,
                                    alt: "",
                                    title: `${member.full_name}(${member.email})`
                                  }, null, 8, ["src", "title"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    title: `${member.full_name}(${member.email})`,
                                    src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                  : 'img/no-user.jpg'
              ,
                                    alt: ""
                                  }, null, 8, ["title", "src"]))
                            ], 8, ["onClick"]),
                            _createVNode("div", {
                              class: 
              member.status === 2
                ? 'member-status-wrap active accepted'
                : 'member-status-wrap accepted'
            
                            }, [
                              _hoisted_4
                            ], 2),
                            _createVNode("div", {
                              class: 
              member.status === 1
                ? 'member-status-wrap active pending'
                : 'member-status-wrap pending'
            
                            }, [
                              _hoisted_5
                            ], 2),
                            _createVNode("div", {
                              class: 
              member.status === 3
                ? 'member-status-wrap active declined'
                : 'member-status-wrap declined'
            
                            }, [
                              _hoisted_6
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      (member.role != 4)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("a", _hoisted_9, [
                              (member.image)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: member.image,
                                    alt: "",
                                    title: `${member.email}`
                                  }, null, 8, ["src", "title"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    title: `${member.email}`,
                                    src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                  : 'img/no-user.jpg'
              ,
                                    alt: ""
                                  }, null, 8, ["title", "src"]))
                            ]),
                            _createVNode("div", {
                              class: 
              member.status === 2
                ? 'member-status-wrap active accepted'
                : 'member-status-wrap accepted'
            
                            }, [
                              _hoisted_10
                            ], 2),
                            _createVNode("div", {
                              class: 
              member.status === 1
                ? 'member-status-wrap active pending'
                : 'member-status-wrap pending'
            
                            }, [
                              _hoisted_11
                            ], 2),
                            _createVNode("div", {
                              class: 
              member.status === 3
                ? 'member-status-wrap active declined'
                : 'member-status-wrap declined'
            
                            }, [
                              _hoisted_12
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_13, [
          _hoisted_14
        ])),
    (_ctx.state.data.showUesrDetails)
      ? (_openBlock(), _createBlock(_component_ToDoListUserPermissionDetail, {
          key: 2,
          activeUuid: _ctx.activePhase.uuid,
          activeMember: _ctx.state.data.selectedMember,
          isShowModal: _ctx.state.data.showUesrDetails,
          onCloseModal: _ctx.closeUserPermissionDetail
        }, null, 8, ["activeUuid", "activeMember", "isShowModal", "onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}